import React, { useState, useEffect, useRef } from "react";
import { fetchPhoneNumber } from "../services/api";
import { NumericFormat, PatternFormat } from "react-number-format";
import { funFacts } from "../data/staticData";
console.log(funFacts);

interface PhoneNumberGameProps {
  selectedCountry: string;
}

const PhoneNumberGame: React.FC<PhoneNumberGameProps> = ({ selectedCountry }) => {
  const [displayNumber, setDisplayNumber] = useState("");
  const [spokenUrl, setSpokenUrl] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [message, setMessage] = useState("");
  const [incorrectFeedback, setIncorrectFeedback] = useState<string | null>(null);
  const [correctCount, setCorrectCount] = useState(0);
  const [nextData, setNextData] = useState<{ display: string, spokenurl: string } | null>(null); // Holds prefetched data
  const audioRef = useRef<HTMLAudioElement | null>(null);

  const [showModal, setShowModal] = useState(false); // Modal visibility state

  const funFact = 
    selectedCountry in funFacts.phone_numbers 
      ? funFacts.phone_numbers[selectedCountry as keyof typeof funFacts.phone_numbers] 
      : null;

  // Fetch the current question
  const loadPhoneNumber = async () => {
    const data = await fetchPhoneNumber(selectedCountry);
    console.log(data);
    setDisplayNumber(data.display);
    setSpokenUrl(data.spokenurl);
  };

  // Prefetch the next question in the background
  const prefetchNext = async () => {
    console.log("in prefetchNext");
    const next = await fetchPhoneNumber(selectedCountry);
    setNextData(next);
  };

  // Initialize by loading the first question and prefetching the next one
  useEffect(() => {
    console.log("first useEffect");
    loadPhoneNumber();
    prefetchNext(); // Prefetch the next question right away
  }, [selectedCountry]);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (inputValue === displayNumber) {
      setMessage("Correct");
      setCorrectCount((prev) => prev + 1);
      setIncorrectFeedback("");

      setTimeout(() => {
        setMessage("");
        setInputValue("");

        // Move the prefetched question to the current state
        if (nextData) {
          setDisplayNumber(nextData.display);
          setSpokenUrl(nextData.spokenurl);
          setNextData(null); // Clear out the prefetched data
        }

        // Prefetch the following question in the background
        prefetchNext();
      }, 1000);
    } else {
      setMessage("Incorrect");
      setIncorrectFeedback(formatFeedback(inputValue, displayNumber));
    }
  };

  const formatFeedback = (input: string, correct: string) => {
    return input
      .split("")
      .map((char, index) => {
        if (char === correct[index]) {
          return `<span style="color: green;">${char}</span>`;
        } else {
          return `<span style="color: red;">${char}</span>`;
        }
      })
      .join("");
  };

  // Play the audio when the spokenUrl is updated after a correct answer
  useEffect(() => {
    console.log("second useEffect");
    if (spokenUrl && audioRef.current) {
      audioRef.current.load(); // Reload the audio with the new source
      audioRef.current.play(); // Play the new audio
    }
  }, [spokenUrl]);

  const numFormat = () => {
    if (selectedCountry === "US") {
      return "(###) ###-####";
    } else if (selectedCountry === "CN") {
      return "### #### ####";
    }
    return "";
  };

  return (
    <div className="phone-number-game">
      <div className="game-header">
        <h2>Phone Number Quiz</h2>
        {funFact && ( // Show the question mark icon only if a fun fact exists
          <button className="info-btn" onClick={() => setShowModal(true)}>
            ❓
          </button>
        )}
        
      </div>
      <p>Correct answers: {correctCount}</p>

      {spokenUrl && (
        <div>
          <audio ref={audioRef} controls>
            <source src={spokenUrl} type="audio/mpeg" />
            Your browser does not support the audio element.
          </audio>

          <form onSubmit={handleSubmit}>
            <PatternFormat
              value={inputValue}
              format={numFormat()}
              allowEmptyFormatting
              mask="_"
              onValueChange={(values) => setInputValue(values.formattedValue)}
              required
            />
            <button type="submit">Submit</button>
          </form>
        </div>
      )}

      {message && <p>{message}</p>}
      {incorrectFeedback && (
        <p
          dangerouslySetInnerHTML={{ __html: incorrectFeedback }}
        />
      )}
      {showModal && funFact && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Fun Facts</h3>
            <div dangerouslySetInnerHTML={{ __html: funFact }} />
            <button onClick={() => setShowModal(false)}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PhoneNumberGame;
